import { apiClient } from "@/core/api/ApiClient";
import { AssetDto, EntityType } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: AssetDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function AssetDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.Asset}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.assetsApi.apiV1AssetsAssetIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          assetId: params.entityId,
          isDeleteCascade: params.isDeleteCascade,
        });
      }}
      {...otherProps}
    />
  );
}
